<template>
    <li class="list-group-item f -gutter-small">
        <div class="icon">
            <i class="glyphicon glyphicon-home" v-if="ex.mean === 'address'"></i>
            <i class="glyphicon glyphicon-envelope" v-if="ex.mean === 'email'"></i>
            <i class="glyphicon glyphicon-earphone" v-if="ex.mean === 'phone'"></i>
            <i class="glyphicon glyphicon-user" v-if="ex.mean === null"></i>
        </div>
        <div class="expand content">
            <div>
                        <span v-for="contact of ex.contacts">
                            <span v-if="$index">+</span>
                            {{ contact.title | shortTitle }}
                            {{ contact.first_name }}
                            {{ contact.last_name }}
                        </span>
                |
                <span class="less-important">{{ ex.staff.name }}</span>
            </div>
            <div class="date">
                {{ ex.date | timeFromNow | ucfirst }}
                <span>({{ ex.date | date 'LL' }})</span>
            </div>
            <div class="summary">
                {{ ex.summary }}

                <span v-if="ex.fee"
                      class="fee">
                    ({{{ ex.fee | money }}})
                </span>
            </div>
        </div>
    </li>
</template>

<style type="text/css"
       scoped>
    .less-important {
        color: grey;
    }

    .summary, .date {
        font-size: 90%;
        margin-top: 5px;
    }

    .date span {
        color: grey;
    }

    .fee {
        color: grey;
    }
</style>

<script type="text/javascript">
    export default {
        props: {
            ex: {
                required: true
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ExchangeRow.vue?5f769695